import { render, staticRenderFns } from "./videoBtn.vue?vue&type=template&id=752723ab&scoped=true&"
import script from "./videoBtn.vue?vue&type=script&lang=js&"
export * from "./videoBtn.vue?vue&type=script&lang=js&"
import style0 from "./videoBtn.vue?vue&type=style&index=0&id=752723ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752723ab",
  null
  
)

export default component.exports